module.exports = __webpack_public_path__ + "img/image-classification.b827e47c.png";